<template>
  <div class="main-conent main-conent-maxheight main-content-rows">
    <search
      @type-change="typeChange"
      @date-change="dateChange"
      @export="exportExcel"
    ></search>

    <el-row v-if="showType === 'preview'" :gutter="20">
      <el-col :span="8">
        <el-table
          class="box-card"
          style="padding:0;"
          stripe
          border
          :data="predict"
          :height="364"
        >
          <el-table-column prop="label" label="日期"></el-table-column>
          <el-table-column prop="value" label="预测结果"></el-table-column>
        </el-table>
      </el-col>
      <el-col :span="16">
        <div class="box-card">
          <echart chartId="wheatScab" :options="options" :height="322"></echart>
        </div>
      </el-col>
      <transition> </transition>
    </el-row>

    <el-row v-show="showType === 'data'">
      <el-col>
        <el-table
          ref="table"
          class="box-card"
          style="padding:0;"
          stripe
          border
          :data="rawData"
          :max-height="600"
        >
          <el-table-column
            prop="collectTime"
            label="日期"
            width="160"
          ></el-table-column>
          <el-table-column
            v-for="(col, index) in cols"
            :key="index"
            :prop="col.key"
            :label="col.name"
            min-width="120"
          ></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import moment from 'moment'
import Search from './components/search'
import Echart from '@/components/Chart'
import { getToken, getPredict, getRawData, getCols } from '@/service/wheat'
import { export_table_to_excel as exceljs } from '@/utlis/exportExcel'

export default {
  components: { Search, Echart },
  data() {
    return {
      showType: 'preview', // 显示类型
      token: '',
      actived: 0, // 激活的设备的 index
      predict: [],
      rawData: [],
      cols: [],
      startDate: moment()
        .startOf('week')
        .format('YYYY-MM-DD'),
      endDate: moment()
        .add(1, 'days')
        .format('YYYY-MM-DD')
    }
  },
  computed: {
    device() {
      return this.scabs[this.actived]
    },
    options() {
      return {
        legend: {
          type: 'scroll',
          left: '40',
          right: '6%',
          pageButtonPosition: 'end',
          pageIconSize: 24,
          inactiveColor: '#dcdfe6',
          selectedMode: 'single',
          textStyle: { color: '#909399', fontSize: 14 },
          pageTextStyle: { color: '#909399', fontSize: 14 },
          top: 0
        },
        dataset: {
          dimensions: ['collectTime', ...this.cols.map(c => c.key)],
          source: this.rawData
        },
        xAxis: { type: 'category', boundaryGap: false },
        yAxis: { type: 'value' },
        series: this.cols.map(c => ({ type: 'line', name: c.name }))
      }
    }
  },
  async mounted() {
    if (this.device) {
      await this.getToken()
      await Promise.all([this.getPredict(), this.getRawData(), this.getCols()])
    }
  },
  methods: {
    async getToken() {
      const { data } = await getToken()
      this.token = data.token
    },
    async getPredict() {
      const { data } = await getPredict(this.device.id)
      this.predict = this.formatPredict(data)
    },
    async getRawData() {
      this.loading = true
      const { data } = await getRawData(this.device.id, {
        startDate: this.startDate,
        endDate: this.endDate
      })
      this.rawData = data.reverse()
      this.loading = false
    },
    async getCols() {
      const { data } = await getCols(this.device.key)
      this.cols = data
    },
    formatPredict(raw) {
      let data = raw && raw[0] ? raw[0] : {}
      let keys = [
        { key: 'first', label: '1日(今天)' },
        { key: 'second', label: '2日' },
        { key: 'third', label: '3日' },
        { key: 'forth', label: '4日' },
        { key: 'fifth', label: '5日' },
        { key: 'sixth', label: '6日' },
        { key: 'seventh', label: '7日' }
      ]
      return keys.map(k => ({
        label: k.label,
        value: data[k.key] || '暂无数据'
      }))
    },
    typeChange(type) {
      this.showType = type
    },
    async dateChange(begin, end) {
      this.loading = true
      this.startDate = begin
      this.endDate = end
      await this.getRawData()
      this.loading = false
    },
    exportExcel() {
      exceljs(this.$refs.table.$el, '赤霉病传感器数据汇总')
    }
  }
}
</script>

<style lang="css" scoped></style>
